import 'babel-polyfill'

// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.

// Set up logrocket. apparently it must be set up before anything else
import 'axios';  // Import after anything that wraps XHR
import LogRocket from 'logrocket';
if (process.env.LOGROCKET) {
  LogRocket.init(process.env.LOGROCKET);
  window.LogRocket = LogRocket
}

import Vue from 'vue'
import App from './App'
import router from './router'
import BootstrapVue from 'bootstrap-vue'
import store from './store/store'
import VeeValidate from 'vee-validate';
import Raven from 'raven-js';
import RavenVue from 'raven-js/plugins/vue';
import VueBus from '@/lib/VueBus';
import VueClipboard from 'vue-clipboard2'

if (process.env.SENTRY_DSN) {
  Raven
    .config(process.env.SENTRY_DSN, {environment: process.env.NODE_ENV})
    .addPlugin(RavenVue, Vue)
    .install();
    console.log('sentry:', process.env.SENTRY_DSN);
}

Vue.use(BootstrapVue);
Vue.use(VueBus);
Vue.use(VueClipboard)

const config = {
  errorBagName: 'errors', // change if property conflicts
  fieldsBagName: 'fields',
  delay: 0,
  locale: 'en',
  dictionary: null,
  strict: true,
  classes: true,
  classNames: {
    touched: 'ng-touched', // the control has been blurred
    untouched: 'ng-untouched', // the control hasn't been blurred
    valid: 'ng-valid', // model is valid
    invalid: 'ng-invalid', // model is invalid
    pristine: 'ng-pristine', // control has not been interacted with
    dirty: 'ng-dirty' // control has been interacted with
  },
  events: 'input|blur',
  inject: true,
  validity: false,
  aria: true
};
Vue.use(VeeValidate, config);

//Globally available components
import '@/components/global.js'


Vue.config.productionTip = false;
if (process.env.NODE_ENV === 'development') {
  Vue.config.devtools = true;
}

// Create the app, and make it available for debugging and testing infrastructure.
window.VueApp = new Vue({
  el: '#app',
  store,
  router,
  template: '<App/>',
  components: { App }
})

// Expose URL config for debugging and testing infrastructure
window.APP_URLS = URLS;



// WEBPACK FOOTER //
// ./src/main.js